import {Injectable} from '@angular/core';
import {ActionWithPayload} from '@catcore/types/base';
import {Action} from '@ngrx/store';

export const RESOURCE_GET = 'FEATURE_RESOURCE_GET';
export const RESOURCE_UPDATE = 'FEATURE_RESOURCE_UPDATE';

@Injectable()
export class ResourceActions {
  static REQUEST_RESOURCE = '[RESOURCE] REQUEST';
  static LOADED_RESOURCE = '[RESOURCE] LOADED';
  static SAVE_RESOURCE = '[RESOURCE] SAVE';
  static SAVE_SUCCESSFUL= '[RESOURCE] SAVE SUCCESSFUL';

  loadResource(resourceRef: string): ActionWithPayload<ResourceAction> {
    return {
      type: ResourceActions.REQUEST_RESOURCE,
      payload: {resourceRef, resource: null},
    };
  }

  resourceLoaded(resource: any): ActionWithPayload<ResourceAction> {
    return {
      type: ResourceActions.LOADED_RESOURCE,
      payload: {resource, resourceRef: null},
    };
  }

  saveResource(resourceRef: string, resource: any): ActionWithPayload<ResourceAction> {
    return {
      type: ResourceActions.SAVE_RESOURCE,
      payload: {resource, resourceRef},
    };
  }

  resourceSaved(resource: any): ActionWithPayload<ResourceAction> {
    return {
      type: ResourceActions.SAVE_SUCCESSFUL,
      payload: {resource, resourceRef: null},
    };
  }
}

interface AppAction {
  type: string;
  payload?: any;
}

export interface ResourceAction {
  resourceRef: string;
  resource: any;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/actions/resource.actions.ts